import { useNavigate } from "react-router-dom";
import { faArrowLeft, faCompass } from "@fortawesome/free-solid-svg-icons";
import { Button, EmptyState } from "../components/UI";
export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <EmptyState
      icon={faCompass}
      title="This page is outside the map"
      message="The address may have changed, or you may not have access to this workspace area."
      action={
        <Button icon={faArrowLeft} onClick={() => navigate("/")}>
          Return to dashboard
        </Button>
      }
    />
  );
}
